import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useRef, useEffect } from "react";

const MySelect = (props) => {
  const {
    value,
    options,
    placeholder,
    onChange = () => {},
    className = "",
  } = props;

  const dropdownRef = useRef(null);
  const listRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const handleSelect = (value) => {
    onChange(value);
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen && listRef.current) {
      const selectedOption = listRef.current.querySelector(`.option-${value}`);
      if (selectedOption) {
        listRef.current.scrollTop =
          selectedOption.offsetTop - selectedOption.offsetHeight;
      }
    }
  }, [isOpen, value]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        onClick={() => setIsOpen((prev) => !prev)}
        className={`border px-4 rounded cursor-pointer h-12 flex items-center gap-4 justify-between bg-white text-xl ${
          isOpen ? "border-primary" : "border-gray-border"
        } ${className || ""}`}
        style={{
          transition: "transform 0.2s ease",
        }}
      >
        {value !== undefined && value !== null && value !== "" ? (
          <span className="text-[#222222]">
            {options.find((c) => c.value === value)?.label}
          </span>
        ) : (
          <span className="text-[#888888]">{placeholder}</span>
        )}
        <FontAwesomeIcon
          icon={faCaretDown}
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
          }}
        />
      </div>

      {isOpen && (
        <div
          className="absolute mt-2 p-2 bg-white rounded w-full z-10 border-gray-border border"
          style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.08)" }}
        >
          <ul
            className="small-scroll text-base  max-h-40 overflow-y-auto"
            ref={listRef}
          >
            {options.map((option) => (
              <li
                key={option.value}
                onClick={() => handleSelect(option.value)}
                className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                  value === option.value
                    ? "font-extrabold text-primary"
                    : "font-medium text-[#888888]"
                } option-${option.value}`}
              >
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MySelect;
